import { Box } from '@factorialco/deprecated-design-system'

import type { TrainingsTrainingClass } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

export function GroupSelector({
  classes,
  selectedClassId,
  setSelectedClassId,
}: {
  classes: TrainingsTrainingClass[]
  selectedClassId: number
  setSelectedClassId: (value: number) => void
}) {
  return (
    <Box maxWidth="s400">
      <Selector.Popover
        mandatory
        blankLabel={i18n.t('trainings.trainings_detail.fundae.group_selector.blank_label')}
        label={i18n.t('trainings.trainings_detail.fundae.group_selector.label')}
        onChange={(selectedClass) => {
          // We select the first by default, just to avoid showing an empty page
          if (!selectedClass) {
            setSelectedClassId(Number(classes.at(0)?.id))
            return
          }
          setSelectedClassId(Number(selectedClass))
        }}
        placeholder={i18n.t('trainings.trainings_detail.fundae.group_selector.placeholder')}
        value={[selectedClassId.toString()]}
      >
        {classes.map((item) => (
          <Selector.Option key={item.id} value={item.id} label={item.name} searchValue={item.name}>
            {item.name}
          </Selector.Option>
        ))}
      </Selector.Popover>
    </Box>
  )
}
